/**
 * Non-translatable course facts. Titles, descriptions, levels, durations and
 * topics live in `app/i18n/courses`, keyed by these slugs.
 *
 * Order here is the order courses appear everywhere on the site.
 */
export const COURSE_SLUGS = [
  "ai",
  "career",
  "algorithms",
  "programming",
  "architecture",
  "web",
  "mobile",
  "server",
] as const;

export type CourseSlug = (typeof COURSE_SLUGS)[number];

export type Course = {
  slug: CourseSlug;
  image: string;
  /** Renders the orange "New" badge; placement stays manual via COURSES order. */
  isNew?: boolean;
};

export const COURSES: Course[] = [
  { slug: "ai", image: "/img/quotes/idea_lamp.webp", isNew: true },
  { slug: "career", image: "/img/quotes/filming.webp", isNew: true },
  { slug: "algorithms", image: "/img/quotes/solving.webp" },
  { slug: "programming", image: "/img/quotes/books.webp" },
  { slug: "architecture", image: "/img/quotes/stone_balance.webp" },
  { slug: "web", image: "/img/quotes/software.webp" },
  { slug: "mobile", image: "/img/quotes/tools.webp" },
  { slug: "server", image: "/img/quotes/checking.webp" },
];

export function getCourse(slug: CourseSlug): Course {
  const course = COURSES.find((c) => c.slug === slug);
  if (!course) throw new Error(`Unknown course slug: ${slug}`);
  return course;
}

export function getRelatedCourses(slug: CourseSlug, limit = 3): Course[] {
  return COURSES.filter((c) => c.slug !== slug).slice(0, limit);
}

export function coursePath(slug: CourseSlug): string {
  return `/course/${slug}`;
}
